<template>
	<b-modal no-close-on-backdrop ref="modal" size="md" hide-footer @hidden="clearModal" @show="init_component">
		<template v-slot:modal-title>
			{{ modalTitle }}
		</template>

		<div class="row">
			<div class="col-12 mb-3">
				<label class="mb-1">{{ $t('monte.congelation.gestionnaire') }}</label>
				<e-select
					v-model="form.gestionnaire"
					track-by="tiers_id"
					label="tiers_rs"
					:options="gestionnaire_options"
					:loading="loading"
					:searchable="true"
					:show-labels="false"
					:allow-empty="false"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
					<template slot="noResult">{{ $t('global.no_result') }}</template>
				</e-select>
			</div>

			<div class="col-12 mb-3">
				<b-form-checkbox v-model="form.indivision">
					{{ $t('monte.congelation.indivision') }}
				</b-form-checkbox>
			</div>

			<div class="col-12 mb-3" v-if="!form.indivision">
				<label class="mb-1">{{ $t('tiers.tiers') }}</label>
				<e-select
					v-model="form.tiers"
					track-by="tiers_id"
					label="tiers_rs"
					:options="tiers_options"
					:loading="loading"
					:searchable="true"
					:show-labels="false"
					:allow-empty="false"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
					<template slot="noResult">{{ $t('global.no_result') }}</template>
				</e-select>
			</div>

			<div class="col-12 text-center mt-2">
				<b-button variant="primary" :disabled="processing" @click="saveGestionnaire">
					<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
					<font-awesome-icon v-else :icon="['far', 'save']" />
					{{ $t('global.sauvegarder') }}
				</b-button>
			</div>
		</div>
	</b-modal>
</template>

<script type="text/javascript">
	import Congelation from '@/mixins/Congelation.js'
	import Tiers from '@/mixins/Tiers.js'

	export default {
		name: 'ModalGestionnaire',
		mixins: [Congelation, Tiers],
		props: ['horse_id'],

		data() {
			return {
				loading: false,
				processing: false,
				editing_gestionnaire: null,
				gestionnaire_options: [],
				tiers_options: [],
				form: {
					gestionnaire: null,
					indivision: false,
					tiers: null
				}
			}
		},

		methods: {
			async init_component() {
				this.loading = true

				const secondaires = await this.loadTiersHorseSecondaires(this.horse_id)
				this.gestionnaire_options = secondaires.filter(s => s.fonction && s.fonction.fonction_label && s.fonction.fonction_label.startsWith('Gestionnaire')).map(s => s.tiers)

				const tiers_horse = await this.loadTiersHeavyCurrentPart(this.horse_id, true)
				const proprietaires = tiers_horse.filter(t => !t.zero).map(t => t.tiers)

				const stock_tiers = await this.getHorseStockTiers(this.horse_id)

				const all_tiers = [...proprietaires, ...stock_tiers]
				const seen = new Set()
				this.tiers_options = all_tiers.filter(t => {
					if (seen.has(t.tiers_id)) return false
					seen.add(t.tiers_id)
					return true
				})

				if (this.editing_gestionnaire) {
					this.prefillForm()
				}

				this.loading = false
			},

			prefillForm() {
				const g = this.editing_gestionnaire

				this.form.indivision = !!g.tiersgestionnaire_indivision

				this.form.gestionnaire = this.gestionnaire_options.find(t => t.tiers_id == g.tiersgestionnaire_gestionnaire) || g.gestionnaire || null

				this.form.tiers = this.form.indivision ? null : (this.tiers_options.find(t => t.tiers_id == g.tiersgestionnaire_tiers) || g.tiers || null)
			},

			clearModal() {
				this.form = { gestionnaire: null, indivision: false, tiers: null }
				this.gestionnaire_options = []
				this.tiers_options = []
				this.editing_gestionnaire = null
			},

			async saveGestionnaire() {
				if (!this.form.gestionnaire) return
				if (!this.form.indivision && !this.form.tiers) return

				this.processing = true

				const params = {
					tiersgestionnaire_gestionnaire: this.form.gestionnaire.tiers_id,
					tiersgestionnaire_tiers: this.form.indivision ? null : this.form.tiers.tiers_id,
					tiersgestionnaire_indivision: this.form.indivision
				}

				const result = this.editing_gestionnaire ? await this.editStallionGestionnaire(this.horse_id, this.editing_gestionnaire.tiersgestionnaire_id, params) : await this.addStallionGestionnaire(this.horse_id, params)

				if (result) {
					this.successToast('toast.info_save_succes')
					this.$emit('submit')
					this.$refs.modal.hide()
				} else {
					this.failureToast('toast.info_save_failed')
				}

				this.processing = false
			},

			show(gestionnaire = null) {
				this.editing_gestionnaire = gestionnaire
				this.$refs.modal.show()
			}
		},

		computed: {
			modalTitle() {
				return this.editing_gestionnaire ? this.$t('monte.congelation.modifier_gestionnaire') : this.$t('monte.congelation.ajouter_gestionnaire')
			}
		}
	}
</script>
